import React from 'react';
import { useParams, useNavigate } from "react-router-dom";

import CardOfCase from '../Components/CardOfCase';
import Logo from '../Components/Logo';

import styles from '../styles/Logo.module.css';

const PageOfCase = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const closeModal = () => {
        navigate('/home')
    };

    return (
        <>
            <a style={{zIndex: '9999'}} className={styles.widthLimitation}><Logo to='/' position='fixed' /></a>
            <CardOfCase closeModal={closeModal} id={id} onCardOfCaseSuccess={() => {}} />
        </>
    )
}

export default PageOfCase;